module.exports = __webpack_public_path__ + "static/media/cartoon1.a790e2b8.png";